<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-12-26 10:38:32
 * @LastEditors: PF
 * @LastEditTime: 2023-08-08 13:50:47
-->
<template>
  <div>
    <el-dialog class="w1200 h830" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">平时成绩录入</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
          <el-container>
            <el-header>
              <!-- 搜索区域 BEGIN -->
              <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

                <el-form-item>
                  <el-select v-model="dataGrid.parms.xqid" placeholder="学期" @change="bjid='';kskmid='';getbanji();bindTable()" class="filter-item" filterable>
                    <el-option v-for="(item, index) in allXq" :key="index" :label="item.xqmc" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="dataGrid.parms.bjid" placeholder="所在班级" @change="kskmid='';getkaoshikemu();bindTable()" class="filter-item" filterable>
                    <el-option v-for="(item, index) in banjilist" :key="index" :label="item.xzbmc" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="dataGrid.parms.kmid" placeholder="考试科目" @change="bindTable()" class="filter-item" filterable>
                    <el-option v-for="(item, index) in kaoshikemu" :key="index" :label="item.kmmc" :value="item.kmid" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="dataGrid.parms.zt" placeholder="状态" clearable @change='bindTable()' class="filter-item" filterable>
                    <!-- 状态：1-已录入，2-已提交，5-审核中，9-审核通过，10-审核不通过 -->
                    <el-option label="未录入" :value="0" />
                    <el-option label="已录入" :value="1" />
                    <el-option label="已提交" :value="2" />
                    <el-option label="审核中" :value="5" />
                    <el-option label="审核通过" :value="9" />
                    <el-option label="审核不通过" :value="10" />
                  </el-select>
                </el-form-item>
              </el-form>
              <!-- 搜索区域 END -->
              <!-- 按钮区域 BEGIN -->
              <div class="button-box">
                <div>
                  <el-button class="w200" type="primary" @click="addClick"><span class="iconfont icon-chuangjian"></span>录入</el-button>
                  <el-button class="w200" type="primary" @click="tijiaoclick()">提交</el-button>
                </div>
                <div class="top_total">已录入{{yilury}}/未录入{{weiluru}}</div>
              </div>
              <!-- 按钮区域 END -->
            </el-header>
            <el-main>
              <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
                <el-table-column label="序号" type="index" width="80" fixed align="center" />
                <el-table-column fixed prop="xsxh" label="学号" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column fixed prop="xsxm" label="学生姓名" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column fixed prop="xsbjmc" label="班级" align="center" show-overflow-tooltip />
                <el-table-column fixed prop="fs" label="分数成绩" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <span :class="scope.row.sfjg==1||scope.row.sfjg==null?'blek':'red'">{{scope.row.fs}}</span>
                    <span v-if="scope.row.ckzt==1">(免考)</span>
                    <span v-if="scope.row.ckzt==2">(免修)</span>
                    <span v-if="scope.row.ckzt==3">(缺考)</span>
                  </template>
                </el-table-column>
                <el-table-column fixed prop="djmc" label="等级成绩" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column fixed prop="jd" label="绩点" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column prop="lrrxm" label="录入人" align="center" show-overflow-tooltip />
                <el-table-column prop="lrsj" label="录入时间" align="center" show-overflow-tooltip width="180" />
                <el-table-column prop="zt" label="状态" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span v-if="scope.row.zt==0">未录入</span>
                    <span v-if="scope.row.zt==1">已录入</span>
                    <span v-if="scope.row.zt==2">已提交</span>
                    <span v-if="scope.row.zt==5">审核中</span>
                    <span v-if="scope.row.zt==9">审核通过</span>
                    <span v-if="scope.row.zt==10">审核不通过</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                  <template #default="scope">
                    <el-button link type="primary" v-if="scope.row.zt==1 || scope.row.zt==10" @click="openEdit=true; row=scope.row">修改</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
            <el-footer>
              <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
            </el-footer>
          </el-container>
        </div>
    </el-dialog>
    <add v-if="openAdd" v-model:openAdd="openAdd" :row="row" @ReturnData="bindTable" />
    <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
    <!-- 办理 弹窗 结束 -->
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { ElMessageBox } from 'element-plus'
import {
  actionPost,
  loadSelect,
  homeCloseWindow
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 搜索区域 开始
const xqid = ref() // 考试名称
const allXq = ref() // 学期
const banjilist = ref() // 班级
const kskmid = ref() // 考试科目id
const kaoshikemu = ref() // 考试科目
// 搜索区域 结束

// 内容区域 开始
const yilury = ref() // 已录入
const weiluru = ref() // 未录入
// 内容区域 结束

// 方法区域 开始
const tijiaoclick = async () => {
  ElMessageBox.confirm('确认要提交吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    const data = {
      menuId: sessionStorage.getItem('menuId'),
      bjid: dataGrid.value.parms.bjid,
      kmid: dataGrid.value.parms.kmid
    }
    const options = {
      url: '/api/v2/jiaowu/chengjixueshengpingshichengji/tijiaoshenpi',
      data: data
    } // [url]接口地址 [data]
    actionPost(options)
      .then((res) => {
        if (res.code === 200) {
          bindTable()
          successPrompt(res.message)
        } else {
          warningPrompt(res.message)
        }
      })
      .catch()
  })
}
// 添加
const addClick = () => {
  if (dataGrid.value.parms.kmid != null) {
    row.value = {
      bjid: dataGrid.value.parms.bjid,
      kmid: dataGrid.value.parms.kmid
    }
    openAdd.value = true
  } else {
    warningPrompt('未查询到科目，不能录入成绩')
  }
}
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openList = ref(false)

// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
          xqid.value = element.id
          getbanji()
        }
      })
    }
  })
}
// 班级
const getbanji = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: banjilist,
    parms: { xqid: xqid.value },
    order: 'xqmc',
    sort: 'asc',
    loadSuccess: function (res) {
      dataGrid.value.parms.bjid = res.data[0].id
      getkaoshikemu()
    }
  })
}
// 考试科目
// 考试科目
const getkaoshikemu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/chengjixueshengpingshichengji/banjikemu',
    data: kaoshikemu,
    parms: { bjid: dataGrid.value.parms.bjid, xqid: xqid.value },
    order: 'kmmc',
    sort: 'asc',
    loadSuccess: function (res) {
      if (res.data.length > 0) {
        dataGrid.value.parms.kmid = res.data[0].kmid
        kskmid.value = res.data[0].kmid
      } else {
        dataGrid.value.parms.kmid = null
        kskmid.value = null
      }
      bindTable()
    }
  })
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xqid', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.pageNo = pageNo || 1
  dataGrid.value.parms.pageSize = pageSize || 100
  dataGrid.value.parms.order = 'xqid'
  dataGrid.value.parms.sort = 'asc'
  dataGrid.value.loading = true
  dataGrid.value.parms.menuId = sessionStorage.getItem('menuId')
  const options = {
    url: '/api/v2/jiaowu/chengjixueshengpingshichengji/pagelistnumber',
    data: dataGrid.value.parms
  } // [url]接口地址 [data]
  actionPost(options).then((res) => {
    dataGrid.value.loading = false
    if (res.code === 200) {
      dataGrid.value.total = res.data.pagelist.total
      dataGrid.value.data = res.data.pagelist.list || []
      yilury.value = res.data.ylrNumber
      weiluru.value = res.data.wlrNumber
      dataGrid.value.multipleSelection = []
      dataGrid.value.pagination = {
        // 返回分页所需数据
        pageNo: pageNo || 1,
        pageSize: pageSize || 100,
        total: res.data.pagelist.total
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.open,
  () => {
    if (props.open === 'pingshichengjiluru') {
      openList.value = true
      getxqlist()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
.red {
  color: red;
}
.button-box {
  justify-content: space-between;
}
</style>
